// src/constants/searchPicklist.ts
export const stringComponent = [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Starts With", value: "starts-with" },
    { label: "Ends With", value: "ends-with" },
    { label: "Like", value: "like" },
    { label: "Contains", value: "contains" },
    { label: "Not Contains", value: "not-contains" },
  ];
  
  export const dateComponent = [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    { label: "Between", value: "between" },
  ];
  
  export const numberComponent=  [
    { label: "Is", value: "is" },
    { label: "Is Not", value: "is-not" },
    { label: "Is Empty", value: "is-empty" },
    { label: "Is Not Empty", value: "is-not-empty" },
    { label: "Less Than", value: "less-than" },
    { label: "Greater Than", value: "greater-than" },
    { label: "Less Than or Equal", value: "less-than-or-equal" },
    { label: "Greater Than or Equal", value: "greater-than-or-equal" }
]
  